/* eslint-disable indent */
import React from 'react';
// components
import GridPageAbstract from '../../GridPageAbstract';
import { LocationBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';
import i18n from '../../../i18';
import {
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    DialogActions,
    Button,
    TextField,
    CircularProgress
} from '@mui/material';
import {
    CloseCircleCustomLinearIcon,
    DocumentTextLinearIcon,
    TickSquareCustomLinearIcon
} from '../../../icons-lib';

import CloseIcon from '@mui/icons-material/Close';

import DialogAbstract from './../../DialogAbstract';
import { purple } from '@mui/material/colors';

export default class MerchantsLocationsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'merchantLocations';
        this.Server = this.props.context.getState().server.merchantLocations;
        this.permissionName = 'approve-merchant-location';

        this.headerStartIcon = LocationBulkIcon;

        this.state = {
            ...this.state,
            isHistoryOpen: false,
            historyData: [],
            selectedMerchant: null,
            postSaveDialogOpen: false,
            postSaveData: null,
            modificationReason: '',
            isSubmitting: false
        };

        this.handleHistoryLogOpen = this.handleHistoryLogOpen.bind(this);
        this.handleHistoryLogClose = this.handleHistoryLogClose.bind(this);
        this.handleMerchantSave = this.handleMerchantSave.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
        this.handlePostSaveDialogClose =
            this.handlePostSaveDialogClose.bind(this);
        this.submitWithReason = this.submitWithReason.bind(this);

        this.exportButton = true;
        this.showHistoryFilters = true;
        this.historyFieldLabels = {
            parentLabel: 'locationHistory',
            statusLabel: 'approvalState',
            dateFromLabel: 'dateFrom',
            dateToLabel: 'dateTo'
        };

        this.searchFields = [
            'name',
            'merchant.name',
            'city',
            'street',
            'zip',
            'wallets.walletNumber',
            'draftWallets.walletNumber'
        ];

        this.hiddenColumns = config?.hiddenColumns?.merchantLocations || [];

        this.Head = [
            {
                id: 'merchantId',
                sortField: 'merchant.name',
                label: 'associatedMerchant',
                alignRight: false,
                cell: 'Associated',
                associatedSettings: { primary: 'name', secondary: 'email' },
                searchType: 'server', // server, client
                searchFields: ['name', 'email'], // for server search
                searchController: 'merchants', // for server search
                from: 'merchants',
                display: 'name',
                object: 'merchant',
                filterCell: 'Context',
                filterBy: 'merchants',
                fallbackDisplay: 'email'
            },
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Translatable'
            },
            {
                id: 'walletNumber',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'accountingEmail',
                label: 'accountingEmail',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'approvalState',
                label: 'approvalState',
                alignRight: false,
                cell: 'Status',
                controller: 'merchantLocations',
                fieldIdName: 'merchantLocationId',
                items: ['pending', 'active', 'rejected', 'archived', 'review'],
                itemsWithPermission: [
                    { name: 'review', permission: 'review-merchant-location' },
                    { name: 'active', permission: 'approve-merchant-location' },
                    {
                        name: 'rejected',
                        permission: 'reject-merchant-location'
                    },
                    {
                        name: 'archived',
                        permission: 'approve-merchant-location'
                    },
                    { name: 'pending', permission: 'approve-merchant-location' }
                ],
                statusMap: {
                    pending: 'review',
                    review: 'active',
                    active: 'rejected',
                    rejected: 'archived',
                    archived: 'pending'
                },
                disableEditor: true,
                filterCell: 'Items',
                filterBy: 'approvalState',
                needTranslate: true
            },
            {
                id: 'approvedUser',
                label: 'approvedUser',
                alignRight: false,
                cell: 'Text',
                display: 'firstName+lastName',
                object: 'approvedUser',
                disableEditor: true,
                filterCell: 'Context',
                filterBy: 'users'
            },
            {
                id: 'shortDescription',
                label: 'shortDescription',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'subtitle',
                label: 'subtitle',
                alignRight: false,
                cell: 'Text'
            },
            { id: 'link', label: 'link', alignRight: false, cell: 'Text' }, //add cell: "Link" to make it a link
            {
                id: 'keywords',
                label: 'keywords',
                alignRight: false,
                cell: 'Tags'
            },
            {
                id: 'locationFiles',
                label: 'locationFiles',
                alignRight: false,
                cell: 'Upload',
                fileType: 'merchant',
                type: 'merchantUpload',
                uploadType: 'multiple',
                fileParent: 'merchantId'
            },
            {
                id: 'categories',
                label: 'categories',
                alignRight: false,
                cell: 'Array',
                display: 'name',
                from: 'merchantCategory',
                primary: 'name'
            },
            { id: 'street', label: 'street', alignRight: false, cell: 'Text' },
            { id: 'zip', label: 'zip', alignRight: false, cell: 'Text' },
            { id: 'city', label: 'city', alignRight: false, cell: 'Text' },
            {
                id: 'province',
                label: 'province',
                alignRight: false,
                cell: 'Entity',
                filterCell: 'Items',
                filterBy: 'province',
                filterField: 'province',
                items: config.provinces
            },
            {
                id: 'googlePlacesId',
                label: 'googlePlacesId',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'longitude',
                label: 'longitude',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'latitude',
                label: 'latitude',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'mobilePhone',
                label: 'mobilePhone',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    checkItemState = (data, state) => {
        const items = Array.isArray(data) ? data : [data];
        return items.some((item) => item.approvalState === state);
    };

    needsApprovalItems = () => {
        const selectedItems = this.List.filter((item) =>
            this.state.selected.includes(item.id)
        );
        return this.checkItemState(selectedItems, 'review');
    };
    needsReviewItems = () => {
        const selectedItems = this.List.filter((item) =>
            this.state.selected.includes(item.id)
        );
        return this.checkItemState(selectedItems, 'pending');
    };
    needsApprovalItem = () => {
        const item = this.List.find(
            (it) => it.id === this.state.menuClickItemId
        );
        return item?.approvalState === 'review';
    };
    needsReviewItem = () => {
        const item = this.List.find(
            (it) => it.id === this.state.menuClickItemId
        );
        return item?.approvalState === 'pending';
    };

    handleChangeStatus = async (status) => {
        const ids = this.state.menuClickItemId
            ? [this.state.menuClickItemId]
            : this.state.selected;
        const id = ids.length === 1 ? ids[0] : null;
        if (id) {
            await this.changeStatus({
                merchantLocationId: id,
                state: status
            });
        } else {
            await this.changeStatus({
                merchantLocationIds: ids,
                state: status
            });
        }
    };

    renderCustomMenuItems() {
        const menuItems = [
            this.allowedAction('review-merchant-location') &&
                this.needsReviewItem() && (
                    <MenuItem
                        onClick={() => this.handleReviewDialogOpen()}
                        key="review"
                    >
                        <DocumentTextLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.review')}
                    </MenuItem>
                ),
            // Activity log disabled
            // this.allowedAction('approve-merchant') && (
            //     <MenuItem
            //         key="historyLog"
            //         onClick={() => this.handleHistoryLogOpen()}
            //     >
            //         <HistoryLogCustomLinearIcon sx={{ mr: 2 }} />
            //         {i18n.t('buttons.historyLog')}
            //     </MenuItem>
            // ),
            this.allowedAction(this.permissionName) &&
                this.needsApprovalItem() && (
                    <MenuItem
                        onClick={() => this.handleActivateDialogOpen()}
                        key="approve"
                    >
                        <TickSquareCustomLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.approve')}
                    </MenuItem>
                ),
            this.allowedAction('reject-merchant-location') &&
                this.needsApprovalItem() && (
                    <MenuItem
                        onClick={() => this.handleRejectDialogOpen()}
                        key="decline"
                    >
                        <CloseCircleCustomLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.decline')}
                    </MenuItem>
                )
        ];
        return menuItems.filter(Boolean);
    }

    // Custom onSave for DialogAbstract
    handleMerchantSave(data) {
        // Open the reason dialog immediately, without auto-saving
        this.setState({
            postSaveDialogOpen: true,
            postSaveData: data,
            modificationReason: ''
        });
    }

    handleReasonChange(e) {
        this.setState({ modificationReason: e.target.value });
    }

    handlePostSaveDialogClose() {
        this.setState({
            postSaveDialogOpen: false,
            postSaveData: null,
            isSubmitting: false
        });
    }

    // When the user confirms the reason dialog
    async submitWithReason() {
        this.setState({ isSubmitting: true });
        const { postSaveData, modificationReason } = this.state;
        const user = this.props.context.getState().userInfo;

        // Call the standard save with data + reason + modifiedBy
        const payload = {
            ...postSaveData,
            modificationReason,
            modifiedBy: user
        };

        // Call the base save
        await super.handleDialogOnSave(payload);

        // Build the activity-log payload
        const logPayload = {
            email: user.email, // e.g. "admin2@gmail.com"
            reason: modificationReason // e.g. "test2"
        };

        try {
            const logRes = await fetch('/api/merchants/activity-log/latest', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': localStorage.token
                },
                body: JSON.stringify(logPayload)
            });
            if (!logRes.ok) {
                throw new Error(`Activity log error: ${logRes.status}`);
            }
            const logResult = await logRes.json();
            console.log('Activity log response:', logResult);
        } catch (err) {
            console.error('Failed to write activity-log:', err);
            // optionally show the error to the user
        }

        // Close the reason dialog
        this.handlePostSaveDialogClose();
    }

    // Override renderDialog to pass the custom onSave
    renderDialog() {
        return (
            <DialogAbstract
                dialogOpen={this.state.dialogOpen}
                dialogData={this.state.dialogData}
                permissions={this.permissions}
                Name={this.Name}
                Head={this.Head}
                Server={this.Server}
                // Direct save without modification reason popup
                onSave={(data) => super.handleDialogOnSave(data)}
                onClose={() => this.handleDialogOnClose()}
            />
        );
    }

    // Render the reason dialog
    renderPostSaveDialog() {
        const {
            postSaveDialogOpen,
            postSaveData,
            modificationReason,
            isSubmitting
        } = this.state;
        return (
            <Dialog
                open={postSaveDialogOpen}
                onClose={this.handlePostSaveDialogClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogContent dividers>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Modification reason"
                        type="text"
                        fullWidth
                        value={modificationReason}
                        onChange={this.handleReasonChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handlePostSaveDialogClose}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        onClick={this.submitWithReason}
                        disabled={!modificationReason.trim() || isSubmitting}
                        startIcon={
                            isSubmitting ? <CircularProgress size={20} /> : null
                        }
                    >
                        {isSubmitting ? 'Saving...' : i18n.t('OK')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        return (
            <>
                {super.render()}
                {this.renderHistoryDialog()}
            </>
        );
    }

    async handleHistoryLogOpen() {
        this.setState({
            selectedMerchant: this.state.menuClickItemId,
            isHistoryOpen: true
        });
        try {
            const res = await fetch(
                `/api/merchants/activity-log/${this.state.menuClickItemId}`,
                { headers: { 'X-Auth-Token': localStorage.token } }
            );
            const json = await res.json();
            this.setState({ historyData: json.data });
        } catch (e) {
            console.error('Failed to load history:', e);
        }
    }

    handleHistoryLogClose() {
        this.setState({ isHistoryOpen: false, historyData: [] });
    }

    renderHistoryDialog() {
        const { isHistoryOpen, historyData, selectedMerchant } = this.state;
        // This is a hook, but from a class we get the theme like this:
        const theme = this.props.context.theme;
        // or keep it in state/props if ThemeProvider is used.

        const formatDate = (iso) => {
            const d = new Date(iso);
            const time = d.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
            const date = d.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });
            return `${time} · ${date}`;
        };

        return (
            <Dialog
                open={isHistoryOpen}
                onClose={this.handleHistoryLogClose}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, fontSize: 20 }}>
                    {i18n.t('History Log', { name: selectedMerchant?.name })}
                    <IconButton
                        aria-label="close"
                        onClick={this.handleHistoryLogClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (Old)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (New)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Date & Time')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed by')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Reason')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {historyData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <Typography color="textSecondary">
                                            {i18n.t('historyLog.noEntries')}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}

                            {historyData.map((row) => {
                                const isChanged =
                                    row.changedFieldOld !== row.changedFieldNew;
                                return (
                                    <TableRow key={row.id}>
                                        {/* OLD */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>

                                            {row.changedFieldOld ? (
                                                <Typography
                                                    variant="body2"
                                                    color="textPrimary"
                                                >
                                                    {row.changedFieldOld}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>

                                        {/* NEW */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>

                                            {row.changedFieldNew ? (
                                                <Typography
                                                    variant="body2"
                                                    // highlight in orange if the value changed
                                                    color={
                                                        isChanged
                                                            ? 'warning.main'
                                                            : 'textPrimary'
                                                    }
                                                >
                                                    {row.changedFieldNew}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>

                                        {/* DATE */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {formatDate(row.dateCreated)}
                                            </Typography>
                                        </TableCell>

                                        {/* CHANGED BY */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: purple[600],
                                                    fontWeight: 500
                                                }}
                                            >
                                                {row.changedBy}
                                            </Typography>
                                        </TableCell>

                                        {/* REASON */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textPrimary"
                                            >
                                                {row.reason}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={this.handleHistoryLogClose}>
                        {i18n.t('Close')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    customRetrieveData = async (list) => {
        const files = list
            .flatMap((item) => item.locationFiles)
            .map((locationFiles) => locationFiles.file);
        await this.preloadContextImages(files);
    };
}
